module.exports = __webpack_public_path__ + "img/pr-6.bffeace3.png";